import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { InvoiceTemplateRow } from "../invoiceTemplates.types";
import { AuditActorCell } from "./AuditActorCell";

export const ArchivedByCell = memo(function ArchivedByCell({
    row,
}: CellContext<ViewTableFeatures, InvoiceTemplateRow, number | null>) {
    return <AuditActorCell userId={row.original.archivedByUserId} />;
});
